<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NlYTQb/tc-custom/9781952225437.jpg?1726519149890" alt="This image is the cover for the book Stealing Manhattan"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stealing Manhattan
      </h1>
      <p class="bookDescription body article font2">
        <p>Punch Stanimirovic insists: “My father, known as Mr. Stan, is the greatest gentleman thief who ever lived—a true genius."  Punch was raised to be an exceptional diamond thief. He could work magic on a safe that would have sent Mandrake the Magician back to the novelty store, and Dr. Strange back to medical school. He and his family risked it all to make the patriarch, Mr. Stan, proud.  Punch’s pop culture sensibilities, his father’s proven skills, and his mother’s artistic input merged to create cinema-style capers—elaborately planned and executed, including a spectacular 1992 New York mega-heist of over one billion dollars in diamonds, gold, and precious gems—and they got away with it.  Many of the crew members went on to invest in real estate, helping to “build the New York skyline”, while others moved to Europe and became the Pink Panthers.  They had one rule: No One Gets Hurt. From daring heists to the ultimate escape, discover the true story of Punch, his extraordinary crew, and his high-society family.  Edgar Award winner and New York Times bestselling author Burl Barer brings to light the remarkable story of four decades and two generations of America’s First Family of kind and generous “altruistic outlaws” in STEALING MANHATTAN: The Untold Story of America’s Billion Dollar Gem Heist Masterminds.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Burl  Barer, Punch Stanimirovic
      </h2>
      
      <p class="authorDescription body article">Burl Barer is an Edgar Award-winning author and accomplished media professional, with a career spanning several decades. Among his many books, his WildBlue Press true crime classic, MURDER IN THE FAMILY, is ranked #3 on the "Ten Best True Crime Books Ever Written," and he is listed as one of America's 100 "MUST READ" authors.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WildBlue Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?43f9e24f